<div class="card-base">
  <div class="card-content-pending-cash-desk-search">
    <div class="chip-container">
      <mat-chip-list>
        <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
          {{ filt.valueView }}
          <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="card-container mat-elevation-z1">
      <div class="clearfix">
        <div class="pull-left div-header-left">
          <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
          <pending-cash-desk-filter #filters></pending-cash-desk-filter>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="card-content margin-botton-medium">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">
          <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="Protocol">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Protocolo" #resColProtocol></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div><b>{{element.Protocol}}</b></div>
              </td>
            </ng-container>
            <ng-container matColumnDef="PatientFullName">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Paciente" #resColPatient></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.PatientFullName}}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="Practice">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Práctica" #resColPractice></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.Practice}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="MedicalOrderAmount">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="50" tile="Importe" #resColMedicalOrderAmount></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.MedicalOrderAmount}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="CashDeskStateDescription">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="50" tile="Estado" #resColCashDeskStateDescription></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.CashDeskStateDescription}}</div>
              </td>
            </ng-container>
            <!-- Star Column -->
            <ng-container matColumnDef="Star" stickyEnd>
              <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <button mat-icon-button [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuItem="matMenu">
                  <button (click)="invoicePatientCashDeskRedirect(element)" mat-menu-item>
                    <mat-icon>edit</mat-icon><span>Generar cobranza</span>
                  </button>
                  <button (click)="cashDeskManualAssociationRedirect(element)" mat-menu-item>
                    <mat-icon>edit</mat-icon><span>Saldar con factura anticipo</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </p-scrollPanel>
        <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
      </div>
    </div>
  </div>
</div>
